export default __webpack_public_path__ + "static/media/O_1.9da64c37.png";